import { createRoute, Link } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { Button } from '@/components/ui/button'
import { RiShieldKeyholeLine } from '@remixicon/react'

export const unauthorizedRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/unauthorized',
	component: UnauthorizedPage,
})

function UnauthorizedPage() {
	return (
		<main className="relative min-h-screen bg-background flex flex-col items-center justify-center overflow-hidden">
			{/* Atmospheric background — warm red/destructive tint */}
			<div
				className="pointer-events-none absolute inset-0"
				style={{
					background: `
						radial-gradient(ellipse 60% 40% at 50% 0%, oklch(0.704 0.191 22.216 / 5%) 0%, transparent 100%),
						radial-gradient(ellipse 50% 50% at 80% 70%, oklch(0.77 0.16 70 / 3%) 0%, transparent 100%)
					`,
				}}
			/>

			{/* Grid pattern */}
			<div
				className="pointer-events-none absolute inset-0 opacity-[0.03]"
				style={{
					backgroundImage: `
						linear-gradient(oklch(1 0 0 / 100%) 1px, transparent 1px),
						linear-gradient(90deg, oklch(1 0 0 / 100%) 1px, transparent 1px)
					`,
					backgroundSize: '64px 64px',
				}}
			/>

			{/* Content */}
			<div className="relative z-10 flex flex-col items-center w-full max-w-xs mx-4">
				<div className="relative flex size-16 items-center justify-center mb-6">
					<div className="absolute inset-0 rounded-full bg-gradient-to-br from-destructive/20 via-destructive/5 to-transparent" />
					<div className="absolute inset-1.5 rounded-full bg-background" />
					<RiShieldKeyholeLine className="relative z-10 size-7 text-destructive/70" />
				</div>

				<h1 className="font-serif text-2xl font-semibold tracking-tight text-foreground mb-2">
					Access Restricted
				</h1>
				<p className="text-sm text-muted-foreground text-center mb-8">
					You must be a member of the Discord server to use this application.
				</p>

				<Button asChild className="w-full h-9">
					<Link to="/sign-in">Try Again</Link>
				</Button>
			</div>

			{/* Bottom fade line */}
			<div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-border/30 to-transparent" />
		</main>
	)
}
